/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Icon from "../icons/Icon";
import LinkComponent from "../LinkComponent";
import ShapeImgWithSubBar from "../ShapeImgWithSubBar";
import ShapeImg from "../ShapeImgWithSubBar/Shape";
import Approach from "./Approach";
import ConstructionSite from "./ConstructionSite";
import Headroom from "./Headroom";
import defaultImg from "./Img/tankstelleDefault.jpg";
import Notes from "./Notes";
import OpeningTimes from "./OpenTimes";
import Owner from "./Owner";

const Headline = styled.h1`
    color: ${({ theme }) => theme.colors.white.toString()};
    font-weight: bold;
    line-height: 1.3em;
    hyphens: auto;
    font-size: 2rem;
    word-break: break-word;
    padding-top: 20px;

    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
          padding-top: 0;
          font-size: 3rem;
          hyphens: unset;
          color: ${theme.colors.red.toString()};
      `}
    `}
`;

const SubBar = styled.div`
    background-color: ${({ theme }) => theme.colors.red.toString()};
    color: ${({ theme }) => theme.colors.white.toString()};
    display: grid;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}

    padding-top: 20px;
    padding-bottom: 20px;
    justify-content: space-between;
    grid-template-columns: repeat(1, 1fr);
    justify-items: left;
    row-gap: 20px;

    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
         grid-template-columns: repeat(2, 1fr);
      `}
    `}

    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
         grid-template-columns: repeat(4, 1fr);
         align-items: flex-start;
      `}
    `}
`;

const SubItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`;

const SubItemsWithIcon = styled.div`
    display: flex;
    column-gap: 10px;
`;

const SubItems = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 1.2rem;
`;

const SubItemHeadline = styled.div`
    font-weight: 600;
`;

const GasStationHeader = ({
    gasStation,
    hints,
    openTimes,
    extensions,
    telephone,
}) => {
    const formatStreetAddress = ({ standort_strasse, standort_nummer }) =>
        [standort_strasse, standort_nummer].filter(Boolean).join(" ");

    const img =
        gasStation &&
        gasStation.mainImage &&
        gasStation.mainImage.image_url &&
        gasStation.mainImage.image_name
            ? css`
                  /* stylelint-disable-next-line string-no-newline */
                  background-image: url("${String(
                      gasStation.mainImage.image_url
                  ) + String(gasStation.mainImage.image_name)}");
              `
            : css`
                  background-image: url("${defaultImg}");
              `;

    if (!gasStation) {
        return null;
    }

    return (
        <>
            <ShapeImgWithSubBar>
                <ShapeImgWithSubBar.ButtonContainer>
                    <LinkComponent
                        goBack
                        link={{ href: "/tankstellen/finder", text: "Zurück" }}
                        icon="arrow-left"
                        leftIcon
                    />
                </ShapeImgWithSubBar.ButtonContainer>
                <ShapeImgWithSubBar.LeftContainer>
                    <Headline>{gasStation.name}</Headline>
                </ShapeImgWithSubBar.LeftContainer>
                <ShapeImgWithSubBar.RightContainer
                    css={css`
                        background-repeat: no-repeat;
                        background-position: center left;
                        background-size: cover;
                        ${img};
                    `}
                >
                    <ShapeImgWithSubBar.ImgFilter>
                        <ShapeImg />
                    </ShapeImgWithSubBar.ImgFilter>
                </ShapeImgWithSubBar.RightContainer>
                <ShapeImgWithSubBar.SubBar>
                    <SubBar>
                        <SubItemsWrapper>
                            <SubItems>
                                <SubItemHeadline>Adresse:</SubItemHeadline>
                                <div>
                                    {gasStation.standort_strasse}{" "}
                                    {gasStation.standort_nummer}
                                </div>
                                <div>
                                    {gasStation.standort_plz}{" "}
                                    {gasStation.standort_ort}
                                </div>
                                {telephone && (
                                    <div
                                        css={css`
                                            display: flex;
                                            column-gap: 4px;
                                        `}
                                    >
                                        Telefon:{" "}
                                        <LinkComponent
                                            link={{
                                                text: telephone,
                                                href:
                                                    "tel:" + String(telephone),
                                            }}
                                            color="white"
                                            underline
                                            bold={false}
                                            fontSize="1.2rem"
                                        />
                                    </div>
                                )}
                            </SubItems>
                            <SubItems>
                                <LinkComponent
                                    link={{
                                        text: "Routenplaner",
                                        href: `https://www.google.com/maps?daddr=${formatStreetAddress(
                                            gasStation
                                        )},${gasStation.standort_plz},${
                                            gasStation.standort_ort
                                        },${gasStation.landesname}`,
                                    }}
                                    icon="route"
                                    color="white"
                                    leftIcon
                                    underline
                                    moveIcon={false}
                                    bold={false}
                                    fontSize="1.2rem"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-gtag="gasStations:routeGoogleMaps"
                                />
                            </SubItems>
                        </SubItemsWrapper>
                        {openTimes &&
                            Array.isArray(openTimes) &&
                            openTimes.length > 0 && (
                                <SubItemsWithIcon>
                                    <Icon iconName="clock" />
                                    <SubItems>
                                        <SubItemHeadline>
                                            Öffnungszeiten:
                                        </SubItemHeadline>
                                        <OpeningTimes openTimes={openTimes} />
                                    </SubItems>
                                </SubItemsWithIcon>
                            )}
                        <SubItemsWrapper>
                            {extensions &&
                                Array.isArray(extensions) &&
                                extensions.length > 0 && (
                                    <Headroom extentions={extensions} />
                                )}
                            {hints &&
                                Array.isArray(hints) &&
                                hints.length > 0 && <Approach notes={hints} />}
                        </SubItemsWrapper>
                        <SubItemsWrapper>
                            {hints &&
                                Array.isArray(hints) &&
                                hints.length > 0 && (
                                    <>
                                        <Notes notes={hints} />
                                        <ConstructionSite notes={hints} />
                                    </>
                                )}
                        </SubItemsWrapper>
                    </SubBar>
                </ShapeImgWithSubBar.SubBar>
            </ShapeImgWithSubBar>
            {gasStation.betreiber &&
                (gasStation.betreiber.inhaber_name ||
                    gasStation.betreiber.inhaber_anschrift ||
                    gasStation.betreiber.inhaber_handelsregister) && (
                    <Owner owner={gasStation.betreiber} />
                )}
        </>
    );
};

export default GasStationHeader;
